import { useState, useEffect } from 'preact/compat'

export const AsanaProjectSyncPlug = (props) => {
  const {
    enabled,
    autoSyncEnabled,
    asanaProjectSyncFeatureFlag,
    enableAutoSyncUrl,
  } = props

  const KEY = 'harvest-asana-integration-plug-dismissed'
  const [dismissAsanaIntegrationPlug, setDismissAsanaIntegrationPlug] =
    useState(localStorage.getItem(KEY) === 'true')
  const onDismissAsanaIntegrationPlug = (evt) => {
    evt.preventDefault()
    setDismissAsanaIntegrationPlug(true)
  }

  useEffect(() => {
    if (dismissAsanaIntegrationPlug) {
      localStorage.setItem(KEY, 'true')
    }
  }, [dismissAsanaIntegrationPlug])

  if (dismissAsanaIntegrationPlug) return null
  if (!enabled) return null
  if (!asanaProjectSyncFeatureFlag) return null
  if (autoSyncEnabled) return null

  return (
    <div className="pds-mt-md pds-px-md pds-py-md asana-integration-plug pds-flex pds-text-sm">
      <div className="pds-text-middle pds-pt-xs pds-flex-fill">
        Time tracking is easier with the project sync
      </div>
      <a
        href={enableAutoSyncUrl}
        className="pds-button pds-button-primary pds-button-sm pds-ml-sm"
        target="_blank"
        rel="noopener"
        data-analytics-element-id="timesheet-day-entry-editor-enable-asana-sync"
      >
        Enable the sync
      </a>
      <button
        type="button"
        onClick={onDismissAsanaIntegrationPlug}
        data-analytics-element-id="timesheet-day-entry-editor-dismiss-asana-sync"
      >
        &times;
      </button>
    </div>
  )
}
